export default "__VITE_ASSET__jZSAxrfS__"